import { render, staticRenderFns } from "./CadastrarColecao.vue?vue&type=template&id=1e4194c0&scoped=true&"
import script from "./CadastrarColecao.vue?vue&type=script&lang=js&"
export * from "./CadastrarColecao.vue?vue&type=script&lang=js&"
import style0 from "./CadastrarColecao.vue?vue&type=style&index=0&id=1e4194c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4194c0",
  null
  
)

export default component.exports